import { Component } from '@angular/core';
import { NavigationService } from '../../navigation/navigation.service';
import { AuthenticationService } from '../authentication.service';
import { LogService } from '../../logging/log.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {
    LOG_SOURCE = 'LoginComponent';

    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly navigationService: NavigationService,
        private readonly logService: LogService
    ) {}

    login() {
        this.logService.info(this.LOG_SOURCE, 'Logging in', {});

        this.authenticationService.login(`${window.location.origin}/${this.navigationService.getHomeRoute()}`);
    }
}
